<template>
  <div class="-tw-mx-8 tw-border-y tw-border-grey-mid">
    <div class="tw-grid tw-grid-cols-10 tw-px-10 tw-divide-x tw-divide-grey-mid tw-min-h-12">
      <div class="tw-col-span-2 tw-py-2 tw-flex tw-items-center tw-cursor-pointer tw-group tw-text-grey-dark">
        Name
      </div>
      <div class="tw-col-span-2 tw-p-2 tw-text-center tw-flex tw-items-center tw-px-8 tw-cursor-pointer tw-group tw-text-grey-dark">
        Email
      </div>
      <div class="tw-col-span-2 tw-p-2 tw-text-center tw-flex tw-items-center tw-px-8 tw-cursor-pointer tw-group tw-text-grey-dark">
        Website
      </div>
      <div class="tw-col-span-2 tw-p-2 tw-text-center tw-flex tw-items-center tw-px-8 tw-cursor-pointer tw-group tw-text-grey-dark">
        Stripe
      </div>
      <div class="tw-col-span-2 tw-p-2 tw-text-center tw-flex tw-items-center tw-px-8 tw-cursor-pointer tw-group tw-text-grey-dark">
        Created At
      </div>
    </div>
  </div>
</template>